import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/history.vue
var o = {
	name: "DtIconHistory",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--history"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "History",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M6 3a.5.5 0 0 1 .5.5v2.191l1.724.862a.5.5 0 0 1-.447.894l-2-1A.5.5 0 0 1 5.5 6V3.5A.5.5 0 0 1 6 3Z",
		fill: "currentColor"
	}, null, -1), r("path", {
		d: "M8.837 1.89a5 5 0 0 0-6.17.387l-.667.6V1.5a.5.5 0 1 0-1 0V4a.5.5 0 0 0 .5.5H4a.5.5 0 1 0 0-1H2.803l.531-.478a4 4 0 1 1-1.312 3.423.5.5 0 1 0-.994.11A5 5 0 1 0 8.837 1.89Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=history.js.map